export default {
  items: [
    {
      name: 'Gerenciamento',
      icon: 'icon-speedometer',
      children: [
        {
          name: 'Captchas',
          url: '/captchas',
          icon: 'fa fa-sign-language'
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/_navBasico.js